export const EMPLOYEE_IDS = {
  GENERAL_MANAGER: "77c0e690-093f-416f-b9e5-b59891879612",
  MEDICAL_MANAGER: "ba4ff210-aeca-465a-aad3-6c50acacb112",
  CHIEF_ACCOUNTANT: "f93f9294-e4be-44c3-abce-e6bbb03f016f",
  HEAD_NURSE: "91d3c79e-cd79-46ef-be7b-5f4c35c605f5",
  INTERCESSOR: "a97f386e-7339-4b3b-9191-962ffdd7f95b"
}
